export default val => {
  const typeUser = {
    'PRODUCT': 'Producto',
    'SERVICE': 'Servicio'
  }
  return typeUser[val]
}
